import controller from './rejected.controller';
import '../student.less';

export default {
  controller,
  template: require('./rejected.html')
};



// WEBPACK FOOTER //
// src/app/components/student/rejected/rejected.component.ts